import {Component, Input, OnInit, Output} from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss']
})
export class TimeComponent implements OnInit {

  @Output()
  response = new EventEmitter();

  @Input()
  question: any;
  @Input()
  id: any;
  @Input() domain;

  public val: any;

  constructor() { }

  ngOnInit() {
  }

  clear() {
    this.val = '';
  }

  onChange() {
    this.response.emit(JSON.stringify({id: this.id, question: this.question, response: this.val}));
  }

}
